export default function AvailableList({
  items,
  selectedItems,
  onToggle,
  search,
  onSearch,
}) {
  return (
    <div className="bg-bg-primary rounded-xl border border-bg-secondary shadow-lg overflow-hidden">
      {/* Header */}
      <div className="bg-bg-secondary px-6 py-4 border-b border-bg-main">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold text-text-primary flex items-center gap-2">
            <svg
              className="w-5 h-5 text-blue-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 10h16M4 14h16M4 18h16"
              />
            </svg>
            Available Teams
          </h3>
          <span className="px-3 py-1 bg-bg-main rounded-full text-sm text-text-secondary">
            {items.length}
          </span>
        </div>

        {/* Search Input */}
        <div className="relative">
          <svg
            className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-text-secondary"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            />
          </svg>
          <input
            placeholder="Search teams..."
            value={search}
            onChange={(e) => onSearch(e.target.value)}
            className="w-full pl-10 pr-4 py-2 rounded-lg bg-bg-main text-text-primary border border-bg-main focus:border-button-primary outline-none transition-colors placeholder:text-text-secondary"
          />
          {search && (
            <button
              onClick={() => onSearch("")}
              className="absolute right-3 top-1/2 transform -translate-y-1/2 text-text-secondary hover:text-text-primary transition-colors"
            >
              <svg
                className="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          )}
        </div>
      </div>

      {/* List */}
      <div className="p-4 max-h-[600px] overflow-y-auto">
        {items.length === 0 ? (
          <div className="text-center py-12">
            <div className="w-16 h-16 bg-bg-secondary rounded-full flex items-center justify-center mx-auto mb-4">
              <svg
                className="w-8 h-8 text-text-secondary"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                />
              </svg>
            </div>
            <p className="text-text-secondary text-sm">No teams found</p>
            {search && (
              <p className="text-text-secondary text-xs mt-1">
                Try adjusting your search
              </p>
            )}
          </div>
        ) : (
          <ul className="space-y-2">
            {items.map((item) => {
              const selected = selectedItems.some((s) => s.id === item.id);

              return (
                <li
                  key={item.id}
                  onClick={() => onToggle(item)}
                  className={`group cursor-pointer p-4 rounded-lg border transition-all duration-200 flex items-center justify-between ${
                    selected
                      ? "bg-emerald-500/10 border-emerald-500/30 opacity-50"
                      : "bg-bg-secondary border-bg-main hover:border-button-primary/50 hover:bg-bg-main"
                  }`}
                >
                  <div className="flex items-center gap-3">
                    <div
                      className={`w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 ${
                        selected
                          ? "bg-emerald-500/20 border border-emerald-500/30"
                          : "bg-gradient-to-br from-blue-500/20 to-purple-500/20 border border-blue-500/30"
                      }`}
                    >
                      {selected ? (
                        <svg
                          className="w-5 h-5 text-emerald-400"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M5 13l4 4L19 7"
                          />
                        </svg>
                      ) : (
                        <svg
                          className="w-5 h-5 text-blue-400"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                          />
                        </svg>
                      )}
                    </div>
                    <span
                      className={`font-medium ${selected ? "text-text-secondary" : "text-text-primary"}`}
                    >
                      {item.nick_name ||
                        item.name ||
                        [item.first_name, item.last_name]
                          .filter(Boolean)
                          .join(" ")}
                    </span>
                  </div>

                  {!selected && (
                    <div className="opacity-0 group-hover:opacity-100 transition-opacity">
                      <svg
                        className="w-5 h-5 text-emerald-400"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                        />
                      </svg>
                    </div>
                  )}
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </div>
  );
}
